// PrintPortal.js
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class PrintPortal extends Component {
  constructor(props) {
    super(props);
    this.containerEl = document.createElement('div'); // 建立容器
    this.externalWindow = null;
    this.state = {
      isDomReady: false, // 新增狀態：追蹤新視窗的 DOM 是否準備就緒
    };
  }

  componentDidMount() {
    // 1. 開啟新視窗
    this.externalWindow = window.open('', 'PrintRentalWindow', 'width=800,height=1200,left=200,top=200'); 
    
    if (this.externalWindow) {
      // 2. 初始化新視窗的 HTML 結構
      this.externalWindow.document.write(`
        <html>
        <head>
          <title>良師塾人文餐飲</title>
          <meta charset="utf-8">
        </head>
        <body>
          </body>
        </html>
      `);
      this.externalWindow.document.close(); // 必須關閉 document.write
      
      // 3. 複製樣式：確保樣式能在內容載入前套用
      // 必須在 document.close() 之後執行
      document.querySelectorAll('link[rel=stylesheet], style').forEach(node => {
          if (node.href && node.href.includes('hot-reload')) return;
          this.externalWindow.document.head.appendChild(node.cloneNode(true));
      });
      
      // 4. 將 React 容器元素掛載到新視窗的 body
      this.externalWindow.document.body.appendChild(this.containerEl);

      // 5. 確保在容器掛載完成後，更新狀態以觸發 Portal 渲染
      this.setState({ isDomReady: true });
      
      // 6. 設定事件監聽，用於視窗關閉時通知父元件
      this.externalWindow.addEventListener('beforeunload', () => {
        this.props.onClose();
      });
    } else {
        // 如果視窗被瀏覽器阻擋 (Popup Blocker)
        console.error("無法開啟新視窗，請檢查瀏覽器是否阻擋了彈出視窗。");
        this.props.onClose(); // 關閉 Modal 狀態
    }
  }

  componentWillUnmount() {
    // 卸載時關閉外部視窗
    if (this.externalWindow) {
        // 在這裡不需要 this.externalWindow.close()，因為 beforeunload 已經處理
        // 但為了確保，可以保留，但可能會觸發兩次 onClose
        // 為了避免問題，我們只在 externalWindow 存在且沒有被 beforeunload 處理時關閉
        if (!this.externalWindow.closed) {
             this.externalWindow.close();
        }
    }
  }

render() {
  if (!this.state.isDomReady) {
    return null; 
  }

  // 確保 externalWindow 存在
  if (!this.externalWindow) {
      return null;
  }
  
  // 核心變動：將 externalWindow 傳遞給子元件
  const childrenWithProps = React.Children.map(this.props.children, child =>
    React.cloneElement(child, { 
      printWindow: this.externalWindow 
    })
  );

  return ReactDOM.createPortal(childrenWithProps, this.containerEl);
  }
}

export default PrintPortal;